import React from "react";
import { css } from "@emotion/react";
import { CSS_COLORS } from "../../styles/styles-css-variables";
import { ReviewTranslations } from "./reviewTranslations";
import { FONTS } from "../../styles/fonts";
import { T } from "../../components/T";

export const PDPReviewFiltersBox: React.FC<{
  filter: number | null;
  resetFilter: () => void;
  t: ReviewTranslations;
}> = ({ filter, resetFilter, t }) => {
  if (filter === null) {
    return null;
  }

  return (
    <div
      className="so-bg-white"
      css={[
        FONTS.SwarovskiFutura300,
        css`
          padding: 12px 20px;
          border-radius: 2em;
          margin-bottom: 16px;

          align-self: center;

          border: 2px solid transparent;
          &:hover {
            // border-color: ${CSS_COLORS.GreenTransparent20};
          }
        `,
      ]}
    >
      <button onClick={resetFilter}>
        <span
          css={[
            FONTS.SwarovskiFutura300,
            css`
              margin-right: 12px;
              line-height: 1;
            `,
          ]}
        >
          <T forcedValue={t("showingOnlyFilteredReviews")}>
            {t("showingOnlyFilteredReviews").value.replace("<value>", filter.toString())}
          </T>
        </span>

        <span className={"u-underline"} css={FONTS.SwarovskiFutura300}>
          <T>{t("showAllReviews")}</T>
        </span>
      </button>
    </div>
  );
};
